export function getFormValues(form: any) {
  const data = new FormData(form as HTMLFormElement);
  const body = {} as any;
  for (const [key, value] of data.entries()) {
    (body as any)[key] = value;
  }
  return body;
}

export default {
  getFormValues,
};
